import { render, staticRenderFns } from "./tagObjectBrowse.vue?vue&type=template&id=91249906&scoped=true"
import script from "./tagObjectBrowse.vue?vue&type=script&lang=js"
export * from "./tagObjectBrowse.vue?vue&type=script&lang=js"
import style0 from "./tagObjectBrowse.vue?vue&type=style&index=0&id=91249906&prod&scoped=true&lang=scss"
import style1 from "./tagObjectBrowse.vue?vue&type=style&index=1&id=91249906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91249906",
  null
  
)

export default component.exports